import { useNavigate } from 'react-router-dom';
import { PolicyModal } from '../components/waitlist/PolicyModal';
import { termsAndConditions } from '../data/policies';
import { usePageMeta } from '../hooks/usePageMeta';

export function Terms() {
  const navigate = useNavigate();

  usePageMeta({
    title: 'Terms and Conditions - PCNGuard',
    description: 'PCNGuard terms and conditions of use for drivers and fleet operators.',
    canonical: 'https://pcnguard.co.uk/terms',
  });

  const handleClose = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen text-slate-50 selection:bg-emerald-500/30 font-sans bg-[#050505]">
      <PolicyModal
        title="Terms and Conditions of Use"
        subtitle="Full PCNGuard terms and conditions of use."
        lastUpdated="09/12/2025"
        content={termsAndConditions}
        onClose={handleClose}
      />
    </div>
  );
}

export default Terms;
